import React, { useState, useEffect } from "react"
import { Redirect, useLocation, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Space, Popconfirm, Button, notification, Input } from "antd"
import { EyeOutlined, EditOutlined, DeleteOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import _ from "lodash"
/* custom component */
import Header from "../../../component/Header/Header"
import { PageContainer, Xtable, Xpagination } from "../../../component/Xcomponent"

/* actions */
import { getPregnancyHighlightsList, getPregnancyHighlightsListReset } from "../../../action/getPregnancyHighlightsListAction"
import { deletePregnancyHighlights, deletePregnancyHighlightsReset } from "../../../action/deletePregnancyHighlightsAction"
import { dateFormat } from "../../../utils";
import PregnancyHighlightsView from "../PregnancyHighlightsView/PregnancyHighlightsView";

const PregnancyHighlightsList = props => {
    /* variables */
    const {
        getPregnancyHighlightsList, getPregnancyHighlightsListReset, getPregnancyHighlightsListState,
        deletePregnancyHighlights, deletePregnancyHighlightsReset, deletePregnancyHighlightsState
    } = props
    const search = useLocation().search;
    const page = new URLSearchParams(search).get('page');
    const [redirect, setRedirect] = useState([false, ""])
    const [refresh, setRefresh] = useState(0)
    const [pagination, setPagination] = useState({
        page: page ? page : 1,
        records: 40
    })
    const [searchText, setSearchText] = useState({})
    const [tableData, setTableData] = useState([])
    const [view, setView] = useState({
        visible: false,
        id: null,
    })

    //Functions

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText({
            ...searchText,
            [dataIndex]: selectedKeys[0]
        })
    }

    const handleReset = (clearFilters, dataIndex) => {
        let remainSearch = _.omit(searchText, [dataIndex])
        clearFilters()
        setSearchText(remainSearch)
    }

    const getColumnSearchProps = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    });
    const columns = [
        {
            title: 'Week',
            dataIndex: 'week',
            key: 'week',
            ...getColumnSearchProps('week', 'Week')
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            render: weight => (<span>{weight}</span>),
            ...getColumnSearchProps('weight', 'Weight')
        },
        {
            title: 'Height',
            dataIndex: 'height',
            key: 'height',
            render: height => (<span>{height}</span>),
            ...getColumnSearchProps('height', 'Height')
        },
        {
            title: 'Days Left for Delivery',
            dataIndex: 'days_left_for_delivery',
            key: 'days_left_for_delivery',
            render: days_left_for_delivery => (<span>{days_left_for_delivery}</span>),
            ...getColumnSearchProps('days_left_for_delivery', 'Days Left for Delivery')
        },
        {
            title: 'Size',
            dataIndex: 'size',
            key: 'size',
            render: size => (<span>{size}</span>),
            ...getColumnSearchProps('size', 'Size')
        },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'action',
            render: (id) => (
                <Space size="small">
                    <Button size="small" shape="circle" icon={<EyeOutlined />} onClick={() => setView({ id: id, visible: true })} />
                    <Link to={`/pregnancy-highlights/edit/${id}`}><Button size="small" shape="circle" icon={<EditOutlined />} /></Link>
                    {/* <Popconfirm
                        title="Are you sure to delete this item?"
                        onConfirm={() => deletePregnancyHighlights({ id: id })}
                        okText="Delete"
                        cancelText="Cancel"
                        okType="danger"
                    >
                        <Button size="small" shape="circle" icon={<DeleteOutlined />} />
                    </Popconfirm> */}
                </Space>
            )
        },
    ];


    /* callbacks */
    useEffect(() => {
        getPregnancyHighlightsList({
            // page: pagination.page,
            // records: pagination.records,
            ...searchText
        })
        // setRedirect([true, `/pregnancy-highlights/list?page=${pagination.page}`])
    }, [refresh, searchText])

    useEffect(() => {
        if (getPregnancyHighlightsListState.apiState === "success") {
            let tableData = []
            getPregnancyHighlightsListState.list.map((row, index) => {
                tableData.push(
                    {
                        key: index,
                        week: row.week,
                        weight: row.weight,
                        height: row.height,
                        days_left_for_delivery: row.days_left_for_delivery,
                        size: row.size,
                        id: row._id,
                    }
                )
            })
            setTableData(tableData)
        }
    }, [getPregnancyHighlightsListState])

    // useEffect(() => {
    //     setRedirect([true, `/pregnancy-highlights/list?page=${pagination.page}`])
    // }, [pagination])

    useEffect(() => {
        if (deletePregnancyHighlightsState.apiState === "success") {
            deletePregnancyHighlightsReset()
            notification["success"]({
                message: deletePregnancyHighlightsState.message,
                placement: "topRight"
            })
            setRefresh(refresh + 1)
        }
        if (deletePregnancyHighlightsState.apiState === "error") {
            deletePregnancyHighlightsReset()
            notification["error"]({
                message: deletePregnancyHighlightsState.message,
                placement: "topRight"
            })
        }
    }, [deletePregnancyHighlightsState])


    return (
        <>
            {redirect[0] &&
                <Redirect to={redirect[1]} />}

            <Header
                title="Pregnancy Data List"
            // rightChildren={<Link to="/pregnancy-highlights/add" ><Button type="primary" ><PlusOutlined />New</Button></Link>}
            />
            <PageContainer>
                {getPregnancyHighlightsListState.apiState === "error" &&
                    <div style={{ height: 500, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} >
                        <p>{getPregnancyHighlightsListState.message}</p>
                        <Button type="primary" onClick={() => setRefresh(refresh + 1)} >TRY AGAIN</Button>
                    </div>
                }

                {getPregnancyHighlightsListState.apiState !== "error" &&
                    <>
                        <Xtable columns={columns} dataSource={tableData} pagination={false} scroll={{ x: 768 }}
                            loading={getPregnancyHighlightsListState.apiState === "loading"}
                        />
                        {/* <Xpagination
                            pageSizeOptions={['25', '50', '100', '500']}
                            showSizeChanger
                            total={getPregnancyHighlightsListState.pagination.total_records}
                            onChange={(page, pageSize) => setPagination({ page: page, records: pageSize })}
                            current={pagination.page}
                            defaultPageSize={pagination.records}
                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                        /> */}
                        <PregnancyHighlightsView id={view.id} visible={view.visible} onClose={() => setView({ visible: false, id: null })} />
                    </>
                }
            </PageContainer>
        </>
    )
}

const mapStateToProps = (state) => ({
    getPregnancyHighlightsListState: state.getPregnancyHighlightsList,
    deletePregnancyHighlightsState: state.deletePregnancyHighlights
});

const mapDispatchToProps = (dispatch) => ({
    getPregnancyHighlightsList: (params) => dispatch(getPregnancyHighlightsList(params)),
    getPregnancyHighlightsListReset: () => dispatch(getPregnancyHighlightsListReset()),
    deletePregnancyHighlights: (params) => dispatch(deletePregnancyHighlights(params)),
    deletePregnancyHighlightsReset: () => dispatch(deletePregnancyHighlightsReset()),

});

export default connect(mapStateToProps, mapDispatchToProps)(PregnancyHighlightsList);